import React from 'react'

/**
 * 통일된 태그 시스템
 * - Status: NEW, 모집중 등 (채운 배경, 강한 컬러)
 * - Category: 웹개발, 디자인 등 (연한 배경)
 * - Tech: React, Java 등 (아웃라인 or 중립색)
 */

// Status 태그 (NEW, 모집중, 마감 등)
interface StatusTagProps {
  children: React.ReactNode
  variant?: 'new' | 'recruiting' | 'closed' | 'matched' | 'draft' | 'submitted' | 'accepted' | 'rejected'
}

export const StatusTag: React.FC<StatusTagProps> = ({ children, variant = 'recruiting' }) => {
  const baseClasses = 'px-2.5 py-1 text-xs font-semibold rounded-lg whitespace-nowrap'
  
  const variantClasses = {
    new: 'bg-red-500 text-white',
    recruiting: 'bg-blue-600 text-white',
    closed: 'bg-gray-500 text-white',
    matched: 'bg-green-600 text-white',
    draft: 'bg-yellow-100 text-yellow-700 border border-yellow-200',
    submitted: 'bg-blue-100 text-blue-700 border border-blue-200',
    accepted: 'bg-green-100 text-green-700 border border-green-200',
    rejected: 'bg-red-100 text-red-700 border border-red-200',
  }

  return (
    <span className={`${baseClasses} ${variantClasses[variant]}`}>
      {children}
    </span>
  )
}

// Category 태그 (웹개발, 디자인 등)
interface CategoryTagProps {
  children: React.ReactNode
}

export const CategoryTag: React.FC<CategoryTagProps> = ({ children }) => {
  return (
    <span className="px-2.5 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-lg whitespace-nowrap">
      {children}
    </span>
  )
}

// Tech 태그 (React, Java 등)
interface TechTagProps {
  children: React.ReactNode
}

export const TechTag: React.FC<TechTagProps> = ({ children }) => {
  return (
    <span className="px-2.5 py-1 text-xs font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg whitespace-nowrap">
      {children}
    </span>
  )
}

